<div class="font-IBM bgm-white">
  <div ng-cloak flex class="p-20 login text-center fx-row xs-fx-col fx-main-center fx-cross-center">
    <div class="xs-fx-flex-50-in-col print-fx-flex-50 gt-xs-fx-flex-50">
      <div class="p-20">
        <img src="../../../../assets/images/login_logo.png">
        <h3 class="text-center" translate="sign_to_ex_acc"></h3>
        <form name="Login" id="login">
          <div class="m-t-30">
            <mat-form-field class="w-70 ds-validate font-IBM lt-md-ew-width-100pct" appearance="outline">
              <mat-label>USERNAME</mat-label>
              <input name="username" [(ngModel)]="userInfo.username" [ngModelOptions]="{standalone: true}" matInput
                validate noempty="true">
            </mat-form-field>
          </div>
          <div class="">
            <mat-form-field class="w-70 ds-validate font-IBM lt-md-ew-width-100pct" appearance="outline">
              <mat-label>PASSWORD</mat-label>
              <input type="password" [(ngModel)]="userInfo.password" [ngModelOptions]="{standalone: true}" matInput
                validate noempty="true">
            </mat-form-field>
          </div>
          <a class="forgot-pass font-IBM" id="forgot-pass" (click)="redirectToForgotPassword()"
            translate="forgot_password"></a>
          <div layout="row" layout-sm="column" class="m-t-20 login-bottom" layout-xs="column"
            layout-align="start center" layout-align-xs="center start" layout-align-sm="center start" layout-wrap>
            <button validate trigger-check="true" type="submit" (success)="loginFunction()"
 class="w-70 b-r-23 btn-project upper-case btn-color c-white lt-md-ew-width-100pct"
              color="primary" mat-raised-button color="" type="submit">{{'sign_in' | translate}}</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>